module.exports = __webpack_public_path__ + "static/media/home-empty-state.02b8d8d7.svg";